<template>
    <div>
        <transition name="dialogfade">
            <k-dialog v-if="showDialog"
                class="edit-condition-dialog edit-document-dialog liabilities-dialog"
                :title="'Liabilities'"
                @close="closeDialog">
                <k-fade :appear="showComparisonSuccess" class="comparison-success">
                    <div v-if="showComparisonSuccess" class="comparison-success__container">
                        <p><span class="k-icon k-i-check-outline k-i-checkmark-outline"></span> The swiftAI Liabilities Comparison Tool Found No Conflicts in This File</p>
                    </div>
                </k-fade>
                <div v-bind:class="['edit-condition__wrapper', { 'comparison-success' : showComparisonSuccess }]" v-if="!isLoading">
                    <div class="edit-condition__detail-tracking">
                        <section class="edit-condition__section-detail">
                            <div class="liabilities-detail__container">
                                <h2 class="section--title title--document-detail">Liabilities Detail</h2>
                            </div>
                            <div class="liabilities__container liabilities-errors__container">
                                <k-tabstrip :selected="selectedLiabilitiesTab" @select="onLiabilitiesTabSelected" :tabs="liabilitiesTabs" class="comparison__tabstrip">
                                    <template v-slot:mismatched>
                                        <div class="liabilities-errors" v-if="liabilitiesFindings.length > 0">
                                            <div v-bind:class="['liability']" v-for="liability in liabilitiesFindings" :key="liability.accountIdentifier">
                                                <p class="liability--name">{{ liability.liability.owner === 'Borrower' ? '(B)' : '(C)' }} {{ liability.reportLiability.name }}</p>
                                                <p class="liability--account">Acct # <span>{{ liability.accountIdentifier }}</span></p>
                                                <p class="liability--type">{{ liability.liability.liabilityType?.split(/(?=[A-Z])/).join(' ') }}</p>
                                                <p class="liability--address">{{ liability.liability.holderAddressStreetLine1 }}</p>
                                                <p class="liability--address">{{ liability.liability.holderAddressCity }} {{ liability.liability.holderAddressState }} {{ liability.liability.holderAddressPostalCode }}</p>
                                                <p class="data-source">Credit Report Data</p>
                                                <div class="liability__info">
                                                    <p v-bind:class="['liability--account', { 'error': liability.unpaidBalanceError }]"><span class="label">Remaining Balance:</span> <span>{{ $options.filters.formatCurrency(liability.reportLiability.unpaidBalance) }}</span></p>
                                                    <p v-bind:class="['liability--account', { 'error': liability.monthlyPaymentError }]"><span class="label">Monthly Payment:</span> <span>{{ $options.filters.formatCurrency(liability.reportLiability.monthlyPayment) }}</span></p>
                                                    <p v-if="liability.reportLiability.creditLoanType !== 'CreditCard'" v-bind:class="['liability--account', { 'error': liability.remainingTermError }]">Remaining Months: <span>{{ liability.reportLiability.monthsRemaining }}</span></p>
                                                </div>
                                                <div class="enc-liability__container">
                                                    <p class="data-source">Application Data</p>
                                                    <div class="liability__info liability__info--errors">
                                                        <p v-bind:class="['liability--account', { 'error': liability.unpaidBalanceError }]"><span class="label">Remaining Balance:</span> <span>{{ $options.filters.formatCurrency(liability.liability.unpaidBalanceAmount) }}</span></p>
                                                        <p v-bind:class="['liability--account', { 'error': liability.monthlyPaymentError }]"><span class="label">Monthly Payment:</span> <span>{{ $options.filters.formatCurrency(liability.liability.monthlyPaymentAmount) }}</span></p>
                                                        <p v-if="liability.reportLiability.creditLoanType !== 'CreditCard'" v-bind:class="['liability--account', { 'error': liability.remainingTermError }]">Remaining Months: <span>{{ liability.liability.remainingTermMonths }}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="liabilities-errors" v-if="liabilitiesFindings.length === 0">
                                            <p class="liabilities--not-found"><span class="k-icon k-i-information k-i-info"></span> No conflicting liabilities found</p>
                                        </div>
                                    </template>
                                    <template v-slot:missing>
                                        <div class="liabilities-errors" v-if="missingLiabilities.length > 0">
                                            <div v-bind:class="['liability']" v-for="liability in missingLiabilities" :key="liability.accountIdentifier">
                                                <p class="liability--name">{{ liability.name }}</p>
                                                <p class="liability--account">Acct # <span>{{ liability.accountIdentifier }}</span></p>
                                                <p class="liability--type">{{ liability.creditLoanType?.split(/(?=[A-Z])/).join(' ') }}</p>
                                                <div class="liability__info liability__info--missing">
                                                    <p v-bind:class="['liability--account']"><span class="label">Remaining Balance:</span> <span>{{ $options.filters.formatCurrency(liability.unpaidBalance) }}</span></p>
                                                    <p v-bind:class="['liability--account']"><span class="label">Monthly Payment:</span> <span>{{ $options.filters.formatCurrency(liability.monthlyPayment) }}</span></p>
                                                    <p v-bind:class="['liability--account']">Remaining Months: <span>{{ liability.monthsRemaining ?? 0 }}</span></p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="liabilities-errors" v-if="missingLiabilities.length === 0">
                                            <p class="liabilities--not-found"><span class="k-icon k-i-information k-i-info"></span> No missing liabilities found</p>
                                        </div>
                                    </template>
                                </k-tabstrip>
                            </div>
                        </section>
                    </div>
                    <div class="edit-condition__attachments">
                        <div class="attachments__header-assign">
                            <h2 class="section--title">Supporting Documents(s)</h2>
                        </div>
                        <k-grid :data-items="creditReports"
                            :columns="attachmentColumns"
                            :sortable="sortable"
                            :sort="attachmentSort"
                            @sortchange="attachmentSortChangeHandler"
                            @rowclick="getCreditReport">
                        </k-grid>
                        <div class="viewer__container">
                          <WebViewer @removeAttchment="RemoveAttachments"  :showEditorButton="false" :selectedAttchement="selectedAttachment" :pdfFile="selectedAttachment.url" v-if="!isAttachmentLoading && selectedAttachment.url" />
                          <div class="document-attachment__loader-container" v-if="isAttachmentLoading">
                            <loader :size="'large'" :type="'pulsing'"></loader>
                          </div>
                          <div v-if="showCreditReportWarning">
                            <p class="liabilities--not-found"><span class="k-icon k-i-information k-i-info"></span> This file currently has no credit report</p>
                          </div>
                        </div>
                    </div>
                </div>
                <k-dialog-actions>
                    <k-button v-bind:class="['dialog__btn dialog__btn--save']" v-on:click="closeDialog">Close</k-button>
                </k-dialog-actions>

                <div class="conditions__loader-container" v-if="isLoading">
                    <p class="progress-notification">{{ progressNotification }}</p>
                    <k-progressbar class="liabilities__progressbar" v-if="progressValue < 50" :value="progressValue" :label-visible="false" :min="0" :max="50" :animation="progressAnimation" />
                    <loader :size="'large'" :type="'infinite-spinner'" v-if="progressValue === 50"></loader>
                </div>
            </k-dialog>
        </transition>

        <transition name="dialogfade">
          <k-dialog v-if="showErrorDialog" :title="errorTitle" class="error__dialog" @close="toggleErrorDialog">
            <p class="error-dialog__msg">{{ errorMsg }}</p>
          </k-dialog>
        </transition>
    </div>
</template>

<script>
    import auth from '../authConfig.js';
    import apiService from '../api/api.service.js';
    import WebViewer from "../components/WebViewer.vue";
    import { Dialog, DialogActionsBar, Window } from '@progress/kendo-vue-dialogs';
    import { Button } from '@progress/kendo-vue-buttons';
    import { Loader } from "@progress/kendo-vue-indicators";
    import { Fade, Reveal, Slide } from "@progress/kendo-vue-animation";
    import { Input, TextArea, Checkbox } from "@progress/kendo-vue-inputs";
    import { TabStrip } from '@progress/kendo-vue-layout';
    import { ProgressBar } from "@progress/kendo-vue-progressbars";
    import { Grid, GridToolbar } from '@progress/kendo-vue-grid';

    import { filterBy } from '@progress/kendo-data-query';
    import { orderBy } from '@progress/kendo-data-query';

    import cloneDeep from 'lodash.clonedeep';

    export default {
        props: ['loanId', 'showDialog'],
        emits: ['dialogclosed', 'requesterror'],
        data() {
            return {
                attachmentColumns: [
                    { field: 'title', title: 'Title' },
                    { field: 'createdBy.entityId', title: 'Added By' },
                    { field: 'createdDate', title: 'Date Added', filter: "date", type: "date", format: "{0:MM/dd/yyyy}" },
                ],
                attachmentSort: [],
                creditReports: [],
                errorAlert: false,
                errorMsg: '',
                errorTitle: '',
                isAttachmentLoading: false,
                isLoading: false,
                liabilities: [],
                liabilitiesFindings: [],
                liabilitiesFindingsError: false,
                liabilitiesLoaded: false,
                liabilitiesTabs: [
                    { title: 'Conflicting', content: 'mismatched' },
                    { title: 'Missing', content: 'missing' }
                ],
                missingLiabilities: [],
                progressAnimation: { duration: 500},
                progressInterval: null,
                progressNotification: 'Fetching Credit Report Data...',
                progressValue: 0,
                reportLiabilities: [],
                selectedAttachment: { url: '', id: '', title: '' },
                selectedLiabilitiesTab: 0,
                showAttachment: false,
                showCreditReportWarning: false,
                showErrorDialog: false,
                showComparisonSuccess: false,
                sortable: { allowUnsort: false, mode: 'single' }
            }
        },
        mounted() {
        },
        watch: {
            async showDialog(val) {
                if (val) {
                    await this.getLiabilities();

                    this.creditReports = this.$store.state.attachments
                        .filter(att => att.title === 'Credit Report' && att.assignedTo && att.assignedTo.entityName === 'Credit Report' )
                        .sort((a, b) => b.createdDate - a.createdDate);

                    if (this.creditReports.length > 0) {
                        this.getCreditReport({ dataItem: { id: this.creditReports[0].id }});
                    } else {
                        this.showCreditReportWarning = true;
                    }

                    this.runLiabilitiesComparison();
                } else {
                    this.showAttachment = false;
                    this.showCreditReportWarning = false;
                    this.selectedAttachment = { url: '', id: '', title: '' };
                    this.isLoading = false;
                    this.isAttachmentLoading = false;
                    this.liabilities = [];
                    this.liabilitiesLoaded = false;
                    this.liabilitiesFindings = [];
                    this.progressValue = 0;
                    this.stopProgressBar();
                    this.progressNotification = 'Fetching Credit Report Data...';
                    this.showComparisonSuccess = false;
                    this.liabilitiesFindingsError = false;
                }
            }
        },
    methods: {
        async RemoveAttachments(id) {
            let tokenResponse = await auth.acquireTokenResponse();
            this.idTokenClaims = tokenResponse.idTokenClaims;

            let removedAttachment = {
                entityId: id,
                entityType: 'Attachment'
            }

            apiService.MoveAttachmentToJunkFolder(this.loanId, this.junkFolderId, removedAttachment, tokenResponse.accessToken)
                .then(res => {
                    this.$emit('documentupdated', removedAttachment.entityId);
                }).catch(error => {
                    this.errorTitle = 'Failed to Remove Attachment';

                    if (error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                    } else {
                        this.errorMsg = '';
                    }

                    this.onRequestError(this.errorTitle, this.errorMsg);
                });
            },
            assignTabBadges() {
                let self = this;

                setTimeout(() => {
                    let tabs = document.querySelectorAll('.comparison__tabstrip .k-link');

                    tabs.forEach((tab, index) => {
                        if (self.liabilitiesTabs[index].title === 'Conflicting') {
                            if (self.liabilitiesFindings.length > 0) {
                                tab.innerHTML = `${self.liabilitiesTabs[index].title}<span class="tab-badge">${self.liabilitiesFindings.length}</span>`;
                            } else {
                                tab.innerHTML = `${self.liabilitiesTabs[index].title}`;
                            }
                        }

                        if (self.liabilitiesTabs[index].title === 'Missing') {
                            if (self.missingLiabilities.length > 0) {
                                tab.innerHTML = `${self.liabilitiesTabs[index].title}<span class="tab-badge">${self.missingLiabilities.length}</span>`;
                            } else {
                                tab.innerHTML = `${self.liabilitiesTabs[index].title}`;
                            }
                        }
                    })
                }, 2000);               
            },
            attachmentSortChangeHandler(evt) {
                this.attachmentSort = evt.sort;

                this.creditReports = orderBy(this.creditReports, this.attachmentSort);
            },
            base64ToBlob(base64, type='application/octet-stream') {
                const binStr = atob(base64);
                const len = binStr.length;
                const arr = new Uint8Array(len);

                for (let i = 0; i< len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                }
                
                return new Blob([arr], {type: type});
            },
            closeDialog() {
                this.$emit('dialogclosed');
            },
            async getCreditReport(evt) {
                if (this.selectedAttachment.id === evt.dataItem.id) return;

                this.selectedAttachment.url = '';
                this.selectedAttachment.id = evt.dataItem.id;
                this.selectedAttachment.title = evt.dataItem.title;

                this.isAttachmentLoading = true;

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                let attachmentsFile = {
                    loanId: this.loanId,
                    attachments: [evt.dataItem.id]
                };

                apiService.GetAttachmentsFileBytes(attachmentsFile, tokenResponse.accessToken)
                    .then(res => {
                        const blob = this.base64ToBlob(res.data.data, 'application/pdf');
                        const url = URL.createObjectURL(blob);

                        this.isAttachmentLoading = false;
                        this.selectedAttachment.url = url;
                        this.showAttachment = true;
                    }).catch(error => {
                        this.selectedAttachment.id = '';

                        this.isAttachmentLoading = false;
                        this.errorTitle = 'Failed to Open Attachment';

                        if(error?.response?.data?.data) {
                        this.errorMsg = "Error: \n\n" + error.response.data.data;
                        } else {
                            this.errorMsg = '';
                        }

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            async getLiabilities() {
                this.isLoading = true;
                this.startProgressBar();

                let tokenResponse = await auth.acquireTokenResponse();
                this.idTokenClaims = tokenResponse.idTokenClaims;

                return apiService.GetLoanVols(this.loanId, tokenResponse.accessToken)
                    .then(res => {
                        this.liabilities = res.data.data.loanVols.applications[0].vols ?? [];

                        if (res.data.data.creditXML) {
                            this.reportLiabilities = res.data.data.creditXML.filter(liability => liability.unpaidBalance && liability.unpaidBalance !== '0');
                        }

                        this.liabilitiesFindingsError = false;
                    }).catch(error => {
                        this.errorTitle = 'Failed to Fetch Liabilities';

                        if (error.response.data.message === 'Failed to fetch XML') {
                            this.errorMsg = 'Failed to fetch underlying credit report data';

                            this.liabilities = error.response.data.data.loanVols.applications[0].vols ?? [];
                        } else {
                            if(error.response.data) {
                            this.errorMsg = "Error: \n\n" + error.response.data.data;
                            } else {
                                this.errorMsg = '';
                            }
                        }

                        this.liabilitiesFindingsError = true;

                        this.onRequestError(this.errorTitle, this.errorMsg);
                    });
            },
            onLiabilitiesTabSelected(evt) {
                this.selectedLiabilitiesTab = evt.selected;
            },
            onRequestError(errorTitle, errorMsg) {
                this.isLoading = false;
                this.isAttachmentLoading = false;
                this.errorAlert = true;

                this.errorTitle = errorTitle;

                if (errorMsg) {
                    this.errorMsg = errorMsg;
                } else {
                    this.errorMsg = 'Please try again';
                }

                this.toggleErrorDialog();
            },
            runLiabilitiesComparison() {
                this.reportLiabilities.forEach(reportLiability => {
                    let liabilityMatches = this.liabilities.filter(liability => liability.accountIdentifier === reportLiability.accountIdentifier);

                    let liability;

                    if (liabilityMatches.length === 1) {
                        liability = cloneDeep(liabilityMatches[0]);
                    } else {
                        liabilityMatches = this.liabilities.filter(liability => liability.accountIdentifier === reportLiability.accountIdentifier && liability.holderName === reportLiability.name);

                        if (liabilityMatches.length === 1) {
                            liability = cloneDeep(liabilityMatches[0]);
                        } else {
                            liability = liabilityMatches.find(l => l.unpaidBalanceAmount === +reportLiability.unpaidBalance);
                        }
                    }

                    if (liability) {
                        let liabilityFinding = {
                            accountIdentifier: liability.accountIdentifier,
                            unpaidBalanceError: false,
                            remainingTermError: false,
                            monthlyPaymentError: false,
                            reportLiability: reportLiability,
                            liability: liability
                        };

                        if (+reportLiability.unpaidBalance !== liability.unpaidBalanceAmount) {
                            liability.hasErrors = true;
                            liability.hasUnpaidBalanceError = true;

                            liabilityFinding.unpaidBalanceError = true;
                        }

                        reportLiability.monthlyPayment = reportLiability.monthlyPayment ?? 0;
                        liability.monthlyPayment = liability.monthlyPaymentAmount ?? 0;

                        if (+reportLiability.monthlyPayment !== liability.monthlyPaymentAmount) {
                            liability.hasErrors = true;
                            liability.hasMonthlyPaymentError = true;

                            liabilityFinding.monthlyPaymentError = true;
                        }

                        reportLiability.monthsRemaining = reportLiability.monthsRemaining ?? 0;
                        liability.remainingTermMonths = liability.remainingTermMonths ?? 0;

                        if (reportLiability.creditLoanType !== 'CreditCard' && +reportLiability.monthsRemaining !== liability.remainingTermMonths) {
                            liability.hasErrors = true;
                            liability.hasMonthsRemainingError = true;

                            liabilityFinding.remainingTermError = true;
                        }
                        
                        if (liability.hasErrors) {
                            this.liabilitiesFindings.push(liabilityFinding);
                        }
                    } else {
                        this.missingLiabilities.push(reportLiability);
                    }
                })

                if (this.progressValue < 50) {
                    this.progressValue = 49;
                }

                setTimeout(() => {
                    this.isLoading = false;
                    this.liabilitiesLoaded = true;

                    if (this.liabilitiesFindings.length > 0 || this.missingLiabilities.length > 0) {
                        this.assignTabBadges();
                    } else {
                        if (!this.liabilitiesFindingsError) {
                            this.showComparisonSuccess = true;
                        }
                    }
                }, 2000);
            },
            startProgressBar() {
                this.progressInterval = setInterval(() => {
                    if (this.progressValue < 50) {
                        this.progressValue += 1;

                        if (this.progressValue > 15 && this.progressValue <= 35) {
                            this.progressNotification = 'Running the swiftAI Liabilities Comparison Tool...';
                        }

                        if (this.progressValue > 35) {
                            this.progressNotification = 'Finalizing Results...';
                        }
                    }
                }, 500);
            },
            stopProgressBar() {
                clearInterval(this.progressInterval);
                this.progressInterval = null;
            },
            toggleErrorDialog() {
                this.showErrorDialog = !this.showErrorDialog;

                if (!this.showErrorDialog) {
                this.errorAlert = false;
                this.errorMsg = '';
                }
            }
        },
        filters: {
            formatCurrency(val) {
                if (val === null || val === undefined || val === '') return '';

                if (val.toString().includes('$')) return val;

                if (isNaN(val)) {
                    val = 0;
                }

                let formatter = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0
                });

                return formatter.format(val);
            }
        },
        components: {
            'k-dialog': Dialog,
            'k-dialog-actions': DialogActionsBar,
            'k-button': Button,
            'loader': Loader,
            'k-input': Input,
            'k-fade': Fade,
            'k-window': Window,
            'k-tabstrip': TabStrip,
            'k-progressbar': ProgressBar,
            'k-grid': Grid,
            WebViewer
        }
    }
</script>

<style>
    @import '/src/assets/css/editConditionDialog.css';
    @import '/src/assets/css/editDocumentDialog.css';
    @import '/src/assets/css/liabilitiesDialog.css';
</style>
